import React from 'react';

export default function FlexColumn(props) {
  // justifyContent alignItems expand
  let style = { ...Styles.flexColumn };
  if (props.justifyContent) style.justifyContent = props.justifyContent;
  if (props.alignItems) style.alignItems = props.alignItems;
  if (props.expand) style = { ...style, ...props.expand };
  const className = props.className ?? '';

  const handleClick = () => {
    if (props.onClick) props.onClick();
  };

  return (
    <div className={className} style={style} onClick={handleClick}>
      {props.children}
    </div>
  );
}

const Styles = {
  flexColumn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    height: '100%',
  },
};
